import React from 'react';
import { useTranslation } from 'react-i18next';

import useScreenSize from '@app/components/Hooks/use-screen-size';
import { NAMESPACE } from '@app/i18n';

const spinKeyframes = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const LoadingSimple = React.memo(function LoadingSimple() {
  const { t } = useTranslation(NAMESPACE.APP_SHELL);
  const isSmallScreen = useScreenSize();

  return (
    <div
      className="splashScreen"
      style={{
        height: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          fontSize: isSmallScreen ? '16px' : '26px',
          marginTop: '0px',
          marginBottom: isSmallScreen ? '10px' : '14px',
          color: '#5e7388',
          fontFamily:
            '"Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
          fontWeight: '400',
          WebkitFontSmoothing: 'antialiased',
          textAlign: 'center',
        }}
      >
        {t('loading.workspace')}
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            width: isSmallScreen ? '24px' : '32px',
            height: isSmallScreen ? '24px' : '32px',
            border: '3px solid #e2e8f0',
            borderTop: '3px solid #718096',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            marginTop: isSmallScreen ? '8px' : '16px',
          }}
        />
      </div>

      <style>{spinKeyframes}</style>
    </div>
  );
});

export default LoadingSimple;
